import { render, staticRenderFns } from "./navigationBar.vue?vue&type=template&id=54a6afd8&scoped=true&"
import script from "./navigationBar.vue?vue&type=script&lang=js&"
export * from "./navigationBar.vue?vue&type=script&lang=js&"
import style0 from "./navigationBar.vue?vue&type=style&index=0&id=54a6afd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a6afd8",
  null
  
)

export default component.exports